<template>
    <b-modal ref="profile_modal"
             size="sm"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">
                        {{__t('INSERT_OTP_CODE')}}
                    </span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                     <div class="panel-container show">
                    <div class="panel-content mb-0">
                        <div class="user_auth">
                            <form class="user" autocomplete="off">
                                <div class="form-group">
                                    <label class="form-label" for="input-live-feedback_usernaotp_code">
                                        {{__t('OTP_DIGITAL')}}
                                    </label>
                                    <b-form-input
                                        :state="otp_code.length == 6"
                                        id="input-live-feedback_usernaotp_code"
                                        v-model="otp_code"
                                        class="form-control form-control-use"
                                        :placeholder="__t('OTP_DIGITAL')">
                                    </b-form-input>
                                </div>

                                <div class="form-group mt-5 pt-5">
                                    <b-button class="btn btn-success btn-user btn-block" :disabled="is_valid" v-on:click="save_settings">
                                        {{__t('SAVE')}}
                                    </b-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
            </div>
        </template>

    </b-modal>
</template>

<script>
export default {
    name: "ext_otp_code",
    props : {
         ext_id : {
             type : Number,
             default : 0,
         }
    },

    data() {
        return  {
            is_show_modal : false,
            is_load : false,
            otp_code : "",
        }
    },

    created() {
        EventBus.$on("glovo_otp",this.show_modal);
    },


    methods : {

        close_modal() {
            this.close()
        },

        close() {
            this.is_show_modal = false;
        },

        show_modal() {
            this.is_show_modal = true;
        },

        save_settings() {
            _core.showloading();
            agr_api.patch('/aggregators/glovo/' + this.ext_id + "/otp_auth/" + this.otp_code).then(({data}) => {
                this.is_load = false;
                _core.hideloading();
                this.close();
            }).catch(({response}) => {
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

    },

    computed : {

        is_valid() {
            if(this.otp_code.length == 6) {
                return false;
            }

            return true;
        },

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-sm";
            }

            return "modal-dialog-left modal-sm";
        },
    }
}
</script>


<style scoped>

</style>
